module.exports = __webpack_public_path__ + "img/MSR.40abfb0f.svg";